import { TypographyDetail } from '@seen/ui'
import type { JSX } from 'react'
import { CopyButton } from '#src/components/core/CopyButton.tsx'
import { EditButton } from '#src/components/patient/detail-content/contact-tab/EditButton.tsx'
import { useIsReadOnly } from '#src/hooks/useIsReadOnly.ts'

interface PhoneDisplayProps {
  phoneNumber?: string
  profile: any // TODO: type this properly with ExtendedProfile
}

export function PhoneDisplay({
  phoneNumber,
  profile,
}: PhoneDisplayProps): JSX.Element {
  const isReadOnly = useIsReadOnly()
  return (
    <div className="group flex items-center gap-1">
      <div className="grid flex-1">
        <TypographyDetail className="leading-none font-semibold text-zinc-950">
          Phone
        </TypographyDetail>
        <a
          href={`tel:${phoneNumber}`}
          className="border-b border-transparent py-1.5 text-sm"
        >
          {phoneNumber}
        </a>
      </div>
      <div className="invisible flex group-hover:visible">
        <CopyButton value={phoneNumber} ariaLabel="Copy phone number" />
        {!isReadOnly && <EditButton profile={profile} field="telecom" />}
      </div>
    </div>
  )
}
